/**
 * 
 */
import WMUFields from "./wmu-fields";

export {
	WMUFields as manager,
};

WMUFields.init();

/**
 * Activate fields on new HTML elements if needed
 */
window.addEventListener( 'wmu/newElements', ( event ) =>
{
	if ( event.detail && event.detail.elements && event.detail.elements.length > 0 )
	{
		event.detail.elements.forEach( ( element ) => WMUFields.update( element ) );
	}
} );